import React, { useEffect } from "react";
import ReactWebChat, { createDirectLine } from "botframework-webchat";

export default function ChatWrapper({ token, onMessageFromBot }) {
  const directLine = createDirectLine({ token });

  useEffect(() => {
    const subscription = directLine.activity$.subscribe((activity) => {
      //if (activity.type === "message" && activity.from.role === "bot") {
        onMessageFromBot(activity);
      //}
    });

    return () => subscription.unsubscribe();
  }, [directLine, onMessageFromBot]);

  const activityMiddleware = () => next => card => {
    const { activity } = card;

    // Filtrado institucional
    const oculto = activity.channelData?.metaData?.oculto === true;

    if (oculto) {
      return () => null; // No renderiza el mensaje
    }

    return next(card); // Renderiza normalmente
  };

  return (
    <ReactWebChat
      directLine={directLine}
      activityMiddleware={activityMiddleware}
    />
  );
}